<template>
    <el-dialog
        class="refund"
        :visible.sync="refundVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Refund"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="refundForm"
                :model="refundForm"
                :rules="rules"
                label-width="110px"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Refund Amount" size="small">
                            <span class="refund-num">$ {{ refundAmount }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="17">
                        <el-form-item label="Amount" prop="amount" size="small">
                            <el-input
                                clearable
                                placeholder=""
                                :max="refundAmount"
                                size="small"
                                v-model="refundForm.amount"
                            >
                                <i slot="prefix">$</i>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- <el-row>
                    <el-col :span="24">
                        <el-form-item>
                            <div class="tip">
                                <i class="el-icon-warning"></i>
                                <span></span>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row> -->
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Submit</el-button
            >
            <el-button size="small" @click="refundVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        var validate = (rule, value, callback) => {
            console.log("this.refundAmount: ", this.refundAmount);
            console.log("value: ", value);
            if (+value > +this.refundAmount) {
                callback(
                    new Error(
                        "Refund amount cannot be greater than order amount."
                    )
                );
            } else {
                callback();
            }
        };
        return {
            refundAmount: "0.00",
            refundForm: {
                amount: "",
            },
            rules: {
                amount: [
                    {
                        validator: validate,
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    methods: {
        save() {
            this.$refs["refundForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    cmofferApi
                        .orderRefund(
                            {
                                refund_amount: this.refundForm.amount,
                                order_id: this.tableItem.id,
                                currency: "USD",
                            },
                            "post"
                        )
                        .then((res) => {
                            this.loading = false;
                            this.closeDialog();
                            this.$parent[this.funcName]();
                            this.$message.success(
                                this.$i18n.locale == "zh" ? "成功" : "Success"
                            );
                        });
                }
            });
        },
        closeDialog() {
            this.refundForm.amount = "";
            this.$refs["refundForm"].clearValidate();
            this.$refs["refundForm"].resetFields();
            this.$emit("update:refundVisible", false);
        },
        changeNum(val) {
            if (+val > +this.refundAmount) {
                this.refundForm.amount = "";
            }
        },
        async initialize() {},
    },
    props: {
        refundVisible: Boolean,
        tableItem: Object,
        funcName: String,
    },
    watch: {
        refundVisible() {
            if (this.refundVisible) {
                console.log("this.tableItem: ", this.tableItem);
                this.refundAmount = (
                    +this.tableItem.act_amount - +this.tableItem.refund_amount
                ).toFixed(2);
                this.initialize();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.refund {
    ::v-deep .container {
        min-height: 100px;
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }

        .el-select {
            width: 100%;
        }

        .el-form-item--small {
            margin-bottom: 5px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
        .el-radio-group {
            width: 100%;
        }
    }
    .refund-num {
        font-size: 18px;
        font-weight: 600;
    }

    .tip {
        padding: 8px 20px;
        font-size: 12px;
        color: #333;
        background-color: #e6f7ff;
        border: 1px solid #bee6ff;
        border-radius: 4px;
        align-self: center;
        display: flex;
        align-items: center;
        line-height: 16px;
        i.el-icon-warning {
            margin-right: 10px;
            color: #1890ff;
            font-size: 16px;
        }
    }
}
</style>
